import { ConsolidatedTransaction } from '../transaction/consolidated-transaction';

/**
 * Timeline item model
 */
export class TimeLineItem {
  /**
   * @constructor
   */
  constructor(
    public date: Date,
    public transactions: ConsolidatedTransaction[]
  ) {}
}
